import { DatabaseHosting } from "@p0security/integrations-db";
import {
  Element,
  InstallSpec,
  ItemComponent,
} from "@p0security/shared/install/types";

export const PostgresComponents = InstallSpec({
  "iam-write": ItemComponent({
    label: "Access management",
    description: "Manage access to a PostgreSQL database.",
    type: "string",
    maturity: "ga",
    schema: {
      hostname: Element({
        label: "Database host",
        description: "The IP address of the database",
        type: "generated",
      }),
      port: Element({
        label: "Database port",
        description: "The database port (defaults to 5432)",
        type: "string",
      }),
      defaultDb: Element({
        label: "Default database",
        description: "Access requests will default to this database (optional)",
        type: "string",
      }),
      hosting: DatabaseHosting,
    },
  }),
});
